function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { Defs, Rect, G, Mask, Use, Path } from "react-native-svg";

var _ref = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(Rect, {
  id: "icon-usb_svg__a",
  width: 40,
  height: 40,
  x: 0,
  y: 0,
  rx: 10
}));

var _ref2 = /*#__PURE__*/React.createElement(G, {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement(Mask, {
  id: "icon-usb_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement(Use, {
  xlinkHref: "#icon-usb_svg__a"
})), /*#__PURE__*/React.createElement(Use, {
  fill: "#00245A",
  xlinkHref: "#icon-usb_svg__a"
}), /*#__PURE__*/React.createElement(G, {
  mask: "url(#icon-usb_svg__b)"
}, /*#__PURE__*/React.createElement(Path, {
  stroke: "#17BF88",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M12.7 28.287h0a4.738 4.738 0 01-.001-6.703l9.236-9.236 6.701 6.701-9.236 9.236a4.739 4.739 0 01-6.702.002zM22.996 13.41l4.578 4.578 3.515-3.515-4.578-4.578z"
}), /*#__PURE__*/React.createElement(Path, {
  stroke: "#17BF88",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.75,
  d: "M26.326 12.537l-.687.687m2.808 1.435l-.686.686"
}), /*#__PURE__*/React.createElement(Path, {
  fill: "#17BF88",
  d: "M21.745 21.815l.693-.693-.692-.691-.693.693.193.192-.547.547H19.39l2.914-2.915.346.346.5-1.5-1.5.5.347.347-3.569 3.568v-1.23l.584-.586a.49.49 0 00.502-.116.49.49 0 00-.693-.693.491.491 0 00-.116.502l-.708.707h-.004v1.851l-1.116 1.116a.87.87 0 10.307.307l1.77-1.77h1.928l.001-.004.67-.67.191.193z"
})));

function SvgIconUsb(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40
  }, props), _ref, _ref2);
}

export default SvgIconUsb;